<template>
  <el-dialog
    class="modal-modify-account"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    custom-class="greater"
  >
    <div class="content" v-loading="isLoading">
      <el-form
        ref="accountForm"
        :rules="rules"
        label-position="right"
        :model="formData"
        class="account-modify__form"
      >
        <el-form-item label="登录账号:" prop="accountName">
          <el-input
            :disabled="formType === 'edit'"
            v-model="formData.accountName"
            placeholder="必填"
            class="form-item__input"
          ></el-input>

          <div v-show="formType !== 'edit'" class="input-tips">*支持输入16个以内的字母或数字，成功后不可修改</div>
        </el-form-item>

        <el-form-item label="用户名称:" prop="userName">
          <el-input v-model="formData.userName" placeholder="必填" class="form-item__input"></el-input>

          <div class="input-tips">*支持输入16个字符以内的中英文、数字</div>
        </el-form-item>

        <el-form-item label="登陆邮箱:" prop="email">
          <el-input v-model="formData.email" placeholder="必填" class="form-item__input"></el-input>
          <el-button v-show="formType == 'edit'" @click="$_resetPwd" class="select__btn">重置登陆密码</el-button>
          <div class="input-tips">*邮箱格式如 help@can-dao.com, 用于接收账号密码</div>
        </el-form-item>

        <el-form-item
          label="登陆手机:"
          prop="phone"
          v-show="formType == 'edit' && formData.phone !== ''"
        >
          <el-input v-model="formData.phone" class="form-item__input" disabled></el-input>
        </el-form-item>

        <el-form-item label="选择角色:" class="is-required" prop="roleName">
          <el-input v-model="formData.roleName" placeholder="单选, 必选" style="width: 440px;"></el-input>
          <el-button @click="$_showSelectRole" class="select__btn">选择</el-button>
          <div class="input-tips">*选中的角色对应其功能权限</div>
        </el-form-item>

        <el-form-item label="备注:" prop="memo">
          <el-input
            type="textarea"
            style="width: 500px; height: 48px;"
            resize="none"
            maxlength="50"
            placeholder="选填, 可支持输入50个字符"
            v-model="formData.memo"
          ></el-input>
          <div class="input-tips">*可支持输入50个字符</div>
        </el-form-item>

        <el-form-item class="status__item" label="状态:">
          <el-radio-group v-model="formData.status" style="margin-top: 6px;">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="edit__btns">
        <el-button class="save__btn" @click="$_submit">保存</el-button>
        <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
      </div>
    </div>

    <select-role
      v-if="modal.show === true && modal.template === 'select-role'"
      :title="modal.title"
      :roles="modal.data.roles"
      :platformKey="formData.platformKey"
      :bindRoleId="formData.bindRoleId"
      @submit="$_callback"
      @close="$_close"
    ></select-role>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import SelectRole from "./modal-select-role";

export default {
  name: "modal-modify-roleName",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    userData: { type: Object, default: {} },
    systemId: { type: Number, default: 0 }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        aid: -1,
        accountName: "", // 登录账号
        userName: "",
        bindRoleId: 0,
        roleName: "",
        email: "",
        memo: "",
        status: 1 // 状态 1 - 启用, 2 - 停用
      },
      modal: {
        show: false,
        template: "",
        title: "",
        data: {}
      },
      rules: {
        accountName: [
          { required: true, message: "请输入登录账号!" },
          {
            validator: (rule, value, callback) => {
              const reg = /^[a-z0-9]{1,16}$/i;
              if (value.match(reg) == null) {
                callback(new Error("请输入16个以内字母或数字!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
          { validator: Utils.validCharmap, trigger: "blur" }
        ],
        userName: [
          { required: true, message: "请输入用户名称!" },
          {
            validator: (rule, value, callback) => {
              if (value.length > 16) {
                callback(new Error("最多为16个字符!"));
              } else if (value.match(/^[\u4e00-\u9fa5A-Za-z\d]+$/) == null) {
                callback(new Error("只支持中文、英文或数字"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
          { validator: Utils.validCharmap, trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入登录邮箱!" },
          { type: "email", message: "邮箱格式不正确!", trigger: "blur" }
        ],
        roleName: [{ required: true, message: "请选择角色!" }],
        memo: [
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 50) {
                callback(new Error("最多50个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },

  methods: {
    //重置密码
    $_resetPwd() {
      const self = this;
      $MessageBox.confirm({
        content: `
          <div>确定重置密码?</div>
          <div>重置后新密码将发送到您的邮箱</div>
        `,
        onOk() {
          self.$service
            .post("resetPwd", {
              aid: self.formData.aid
            })
            .then(result => {
              $MessageBox.alert({ content: result.msg });
            });
        }
      });
    },
    // 关闭本组件发起的弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.data = {};
      this.modal.title = "";
    },
    // 选择角色弹窗回调
    $_callback(role) {
      this.formData.bindRoleId = role.rid;
      this.formData.roleName = role.roleName;
      this.$_close();
    },
    // 打开选择角色弹窗
    $_showSelectRole() {
      this.isLoading = true;
      // 先获取角色数据
      this.$service
        .post("getRoles", {
          status: 1,
          createType: 0, // 角色类型 0:所有角色 1:预设角色 2:自定义角色
          pageType: 0, // 角色管理页面类型 0：系统角色管理 1：运营账号管理
          pageNow: 1,
          pageSize: 999
        })
        .then(result => {
          this.isLoading = false;
          if (result.$.checkResult(result, true)) {
            this.modal.data = {
              roles: result.data.rows.concat([])
            };
            this.modal.title = "选择账号所属的角色";
            this.modal.template = "select-role";
            this.modal.show = true;
          }
        });
    },
    // 保存
    $_submit() {
      const self = this;
      this.$refs["accountForm"].validate(valid => {
        if (valid) {
          let action = "addAccount";
          let postData = {
            accountName: this.formData.accountName,
            userName: this.formData.userName,
            bindRoleId: this.formData.bindRoleId || 1,
            email: this.formData.email,
            memo: this.formData.memo,
            status: this.formData.status
          };
          if (this.formType === "add") {
            Object.assign(postData, { accountName: this.formData.accountName });
          } else if (this.formType === "edit") {
            action = "editAccount";
            Object.assign(postData, { aid: this.formData.aid });
          }
          self.isLoading = true;
          self.$service.post(action, postData).then(result => {
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.$emit("callback");
                  self.visible = false;
                }
              });
            } else {
              self.isLoading = false;
            }
          });
        }
      });
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  created() {
    if (this.formType === "edit" && Object.keys(this.userData).length > 0) {
      this.formData.aid = this.userData.aid;
      this.formData.accountName = this.userData.accountName;
      this.formData.userName = this.userData.userName;
      this.formData.bindRoleId = this.userData.bindRoleId;
      this.formData.roleName = this.userData.roleName;
      this.formData.email = this.userData.email;
      this.formData.memo = this.userData.memo || "";
      this.formData.status = this.userData.status;
      this.formData.phone = this.userData.phone || "";
    }
  },
  mounted() {
    this.visible = true;
  },
  components: {
    SelectRole
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: {
    left: 30px;
    top: 24px;
  }
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
  .account-modify__form {
    .form-item__input {
      width: 440px;
      height: 28px;
    }
  }
}
.reset-pwd__btn {
  background: none;
  color: #1895dd;
  text-decoration: underline;
  margin-left: 8px;
}
.select__btn {
  margin-left: 8px;
}
.input-tips{
  display: inline-block;
  margin-left:10px;
}
</style>
